import { useEffect } from 'react'
import { useUser } from '../contexts/UserContext'
import { useAuthInfo } from '@propelauth/react'

function User() {
    const authInfo = useAuthInfo()
    const rolesPropel =
        authInfo.orgHelper.getOrgs()[0].userInheritedRolesPlusCurrentRole
    const orgIdPropel = authInfo.orgHelper.getOrgs()[0].orgId

    const { user, orgId, setUser, setOrgId, roles, setUserRoles } = useUser()

    useEffect(() => {
        setUser(authInfo.user)
        setOrgId(orgIdPropel)
        setUserRoles(rolesPropel)
    }, [authInfo])
}

export default User
